/**
 * The load-bearing "is this part/operation identity present?" rule, shared by
 * the host↔embed plumbing (useJobDocsIframe builds the grid URL; the
 * JobDocsDocumentHeader renders the operation label).
 *
 * Numeric/string `0` is a VALID part/operation id — `null`/`undefined` and the
 * empty string are the only "absent" values. This is deliberately NOT a
 * truthiness check: a `0` id (and, by the same rule, the string `'0'`) must
 * survive as present.
 *
 * @param {unknown} value Candidate id.
 * @returns {boolean} `true` unless the value is `null`, `undefined`, or `''`.
 */
export function hasValue(value) {
  return value != null && value !== '';
}
